// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Articles_wrapper__3Hat7","title":"Articles_title__1gsO5","articles":"Articles_articles__3W2KI","articleimg":"Articles_articleimg__1u5lT"};